export default __webpack_public_path__ + "static/media/IconDesc_SuperComputer.256.183e4432.png";